<template>
  <div
    v-if="currentView!=='Home' && currentView!=='TicketInfo' && !loading && false"
    class="breadcrumb"
    :class="{ 'background': currentView === 'SubjectDetails' }"
  >
    <router-link
      class="home"
      :to="{ name: 'Home' }"
    >
      Início
    </router-link>
    <div
      v-for="crumb in buildCrumbs"
      :key="crumb.name"
      class="link"
    >
      <SvgElement name="ArrowRight" />
      <router-link
        class="link__text"
        :to="crumb.path"
      >
        {{ crumb.name }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BreadCrumb',
  props: {
    currentView: {
      type: String,
      required: true,
      default: 'Home',
    }
  },

  computed: {
    ...mapGetters([
      'getCategories',
      'categorySubjects',
      'getManifestation',
      'selectedSubject'
    ]),

    loading() {
      if(!this.getCategories){
        return true;
      } else if(this.currentView === 'SubjectDetails' && !this.categorySubjects){
        return true;
      } else {
        return false;
      }
    },

    buildCrumbs(){
      let crumbs = [];

      const routes = this.$route.fullPath.split('/').filter(crumb => crumb !== '' && crumb.slice(0,6) !== '#state');

      const removeState = routes[routes.length - 1].search(/#state/);

      if(removeState !== -1){
        routes[routes.length - 1] = routes[routes.length - 1].slice(0, removeState);
      }

      let newRoutes = routes;

      for (let i=0; i<routes.length; i++) {
        const crumbModel = {
          name: decodeURI(newRoutes[i].charAt(0).toUpperCase() + newRoutes[i].slice(1)),
          path: ( i>0 ? `${crumbs[i-1].path}/${routes[i]}` : `/${routes[i]}` ),
        };

        crumbs.push(crumbModel);

        switch (crumbs[i].name) {
          case 'Categorias':
            crumbs[i].name = 'Serviços';
            break;
          case 'Solicitacoes':
            crumbs[i].name = 'Minhas Solicitações';
            break;
          case 'Duvidas-frequentes':
            crumbs[i].name = 'Dúvidas';
            break;
          case 'Manifestacao':
            crumbs[i].name = 'Manifestacão';
            break;
          case 'Servico':
            crumbs[i].name = 'Serviço';
            break;
          default:
            break;
        }

        const foundSubject = this.getCategories.concat(this.categorySubjects)
          .find(subject => subject.slug_name === crumbs[i].name.toLowerCase());

        if (foundSubject) {
          crumbs[i].name = foundSubject.name;
        }
      }

      const manifestationIndex = crumbs.findIndex(el => el.name === 'Manifestacão');

      if ((this.currentView === 'SolicitationMake' || this.currentView === 'SolicitationFinish') && (!this.getManifestation || !this.selectedSubject.allow_anonymous)) {
        crumbs.splice(manifestationIndex, 1);
      }

      return crumbs;
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  display: none;

  @include screen(tablet-big-up) {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 1.25rem 8% 0;
    width: 100%;
    font-size: $text-xs;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .home {
    font-weight: $font-bold;
    color: $primary;
  }

  .link {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: $font-bold;
    color: $primary;

    svg {
      height: 0.625rem;
      color: $gray-share-button;
    }

    &__text {
      text-overflow: ellipsis;
      max-width: 200px;
      white-space: nowrap;
      overflow: hidden;
    }

    &:last-child {
      font-weight: $font-normal;
      color: $gray-share-button;
    }
  }

  @media print {
    display: none;
  }
}

.background {
  background-color: $primary-light;
}
</style>